import { removeEmptyQueryString } from '@/utils'

export default {
  namespaced: true,
  state: () => ({
    cartTracking: {
      tracking_id: null,
      cart_type_id: null, // 購入画面（LPカート/ショップEC）を判断するID
      tracking_start_date: null,
      customer_id: null,
      email: null,
      phone_number: null,
      line_id: null,
      url_clicked: false,
    },
    cartAbandonmentSetting: {
      cart_abandoned_flag: false,
      lp_flag: false,
      customer_target_flag: false,
      guest_target_flag: false,
      individual_setting_flag: false,
    },
  }),
  getters: {
    cartTrackingData(state) {
      return state.cartTracking
    },
    cartAbandonmentFlags(state) {
      return state.cartAbandonmentSetting
    },
  },
  actions: {
    async SET_CART_TRACKING({ commit }, cartTrackingData) {
      commit('SET_CART_TRACKING', cartTrackingData)
    },
    async SET_CART_ABANDONMENT_SETTING({ commit }, cartAbandonmentSettingData) {
      commit('SET_CART_ABANDONMENT_SETTING', cartAbandonmentSettingData)
    },
  },
  mutations: {
    SET_CART_TRACKING(state, cartTrackingData) {
      state.cartTracking = removeEmptyQueryString(cartTrackingData)
    },
    SET_CART_ABANDONMENT_SETTING(state, cartAbandonmentSettingData) {
      state.cartAbandonmentSetting = cartAbandonmentSettingData
    },
  },
}
